import { EntityConfig } from './entity-registry';
import { GenericTableColumn, GenericTableAction } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../../models/GenericCRUD/Filter';

// Configuración para Arqueo y Cierre de Caja
const tableColumns: GenericTableColumn[] = [
  { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
  { name: 'Fecha', active: true, type: 'date', key: 'closure_date', sort: true },
  { name: 'Banco/Caja', active: true, type: 'text', key: 'bank.name', sort: false },
  { name: 'Saldo Inicial', active: true, type: 'currency', key: 'opening_balance', sort: true },
  { name: 'Ingresos', active: true, type: 'currency', key: 'total_income', sort: true },
  { name: 'Gastos', active: true, type: 'currency', key: 'total_expenses', sort: true },
  { name: 'Saldo Final', active: true, type: 'currency', key: 'closing_balance', sort: true },
  { name: 'Diferencia', active: true, type: 'currency', key: 'difference', sort: true },
  { name: 'Estado', active: true, type: 'text', key: 'status_label', sort: true }
];

const formFields: GenericFormField[] = [
  { name: 'closure_date', type: 'date', label: 'Fecha de Cierre', validations: 'required', colspan: 1, defaultValue: 'today' },
  { name: 'bank_id', type: 'select', label: 'Banco/Caja', url: '/bank/all', validations: 'required', singleSelection: true, colspan: 1 },
  { name: 'opening_balance', type: 'number', label: 'Saldo Inicial', validations: 'required', colspan: 1 },
  { name: 'cash_breakdown', type: 'denominations', label: 'Arqueo (recuento por billetes)', validations: '', colspan: 2 },
  { name: 'cash_withdrawn', type: 'number', label: 'Retirada a banco', validations: '', colspan: 1 },
  { name: 'float_retained', type: 'number', label: 'Fondo de cambio que queda', validations: '', colspan: 1 }
];

const tableActions: GenericTableAction[] = [
  {
    name: 'Editar',
    key: 'edit',
    form: {
      method: 'PUT',
      successTitle: 'Cierre actualizado',
      errorTitle: 'Error al actualizar',
      fields: formFields,
      name: 'cierre',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      originalUpdateApiSlug: '/cash-closure/update/{{id}}',
      updateApiSlug: '',
      originalFormTitle: 'Editar Cierre',
      formTitle: 'Editar Cierre',
      formButtonTitle: 'Guardar',
      width: '3xl'
    },
    completeForm: true,
    replaceAllRowOnResponse: true,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
    confirmation: false,
    showIf: (item: any) => item.status === 'open'
  },
  {
    name: 'Cerrar caja',
    key: 'close',
    method: 'POST',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M8 11v-4a4 4 0 0 1 8 0v4" /></svg>',
    confirmation: true,
    questionText: '¿Cerrar esta caja? No se podrá modificar después.',
    confirmText: 'Sí, cerrar caja',
    cancelText: 'Cancelar',
    actionSlug: '/cash-closure/close/{{id}}',
    showIf: (item: any) => item.status === 'open'
  },
  {
    name: 'Eliminar',
    key: 'delete',
    method: 'DELETE',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
    confirmation: true,
    questionText: '¿Desea eliminar este cierre de caja?',
    deleteRowOnResponse: true,
    actionSlug: '/cash-closure/delete/{{id}}',
    showIf: (item: any) => item.status === 'open'
  }
];

const filters: Filter[] = [
  {
    type: 'date-between',
    key: 'closure_date',
    operator: 'between',
    placeholder: 'Fecha'
  },
  {
    type: 'select',
    key: 'bank_id',
    operator: 'in',
    placeholder: 'Banco/Caja',
    url: '/bank/all'
  },
  {
    type: 'select',
    key: 'status',
    operator: 'in',
    placeholder: 'Estado',
    optionsList: [
      { id: 'open', name: 'Abierto' },
      { id: 'closed', name: 'Cerrado' },
      { id: 'reconciled', name: 'Conciliado' }
    ]
  }
];

/**
 * Configuración completa de la entidad Arqueo y Cierre de Caja
 */
export const cashClosuresConfig: EntityConfig = {
  id: 'cash-closures',
  name: 'Arqueo y Cierre',
  icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/></svg>',

  tableColumns,
  formFields,
  tableActions,
  filters,

  form: {
    successTitle: 'Cierre creado correctamente',
    errorTitle: 'Error al crear cierre',
    method: 'POST',
    fields: formFields,
    name: 'cierre',
    createButtonTitle: 'Nuevo Cierre de Caja',
    cols: 2,
    createApiSlug: '/cash-closure/store',
    formTitle: 'Crear Cierre de Caja',
    formButtonTitle: 'Crear Cierre',
    width: '3xl'
  },

  table: {
    columns: tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/cash-closure/index',
    paginate: true,
    name: 'cierres',
    actions: tableActions,
    // Sin vista de detalle: no existe ruta de detalle de cierre (evita ir al dashboard).
    details: false
  },

  useModalForm: false
};
